import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type1StringUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type1String", configService);
    }
}
